<style lang="less" scoped>
.td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.after {text-align: left;background-color: #fcfcfc;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;}
table {border-collapse: collapse;width: 100%;}
/deep/ .el-input .el-input__inner {width: 400px;}
/deep/ .el-textarea .el-textarea__inner {width: 400px;}
.btn_left_td {border-right: none;}
.btn_right_td {border-left: none;}
/deep/ .el-checkbox .el-checkbox__input .el-checkbox__inner {border-radius: 50%;}
/deep/.el-form-item {margin-bottom: 0;}
.btnfixed {margin: 0px auto;height: 60px;z-index: 9999;}
.btnfixed .el-button {height: 40px;margin: 10px auto;margin-top: 10px;}
/deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <div class="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>证书标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入证书标题" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
        <td class="td_left">
          <span v-if="isMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>内容
          </td>
        <td class="after">
          <el-form-item>
            <el-input type="textarea" :rows="4" placeholder="请输入证书内容" v-model="form.content" class="Category_name"></el-input>
          </el-form-item>
        </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>证书图片
          </td>
          <td class="after">
            <el-upload
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('authority')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发证机构
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.authority" placeholder="请输入发证机构" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('fromtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发证日期
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.fromtime" value-format="timestamp" type="datetime" placeholder="请选择发证日期"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('totime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>到期日期
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.totime" value-format="timestamp" type="datetime" placeholder="请选择到期日期"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr" v-if="this.$route.path === '/QyzsUpdate'">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>添加时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
      <div class="btnfixed">
        <el-button type="success" @click="addData">添加</el-button>
        <el-button @click="cancelfn()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['companyName'],
  data()
  {
    return {
      url: '',
      form: {
        title: '',
        content: '',
        authority: '',
        fromtime: '',
        totime: '',
        addtime: '',
        edittime: ''
      },
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      //企业ID
      companyid: null,
      //表名
      tabname: 'dmcn_honor',
      //fld表数据
      fldData: [],
      hideUploadEdit: false
    }
  },
  async created()
  {
    this.getCompanyid()
    this.fldData = await window.public.validation(this.tabname)
  },
  methods: {
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    getCompanyid()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 26,
        _exp: `company = '${this.companyName}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.companyid = ret[0].id
      })
    },
    //添加
    addData()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 47,
        retAtt: 1,
        title: this.form.title,
        content: this.form.content,
        authority: this.form.authority,
        fromtime: (this.form.fromtime / 1000),
        totime: (this.form.totime / 1000),
        addtime: (this.form.addtime / 1000) || (Date.parse(new Date()) / 1000),
        edittime: (this.form.edittime / 1000) || (Date.parse(new Date()) / 1000),
        thumb: this.form.thumb,
        companyid: this.companyid,
        examine: 1
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '2')
        }
      })
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    },
    //取消(移除Tabs页)
    cancelfn(that)
    {
      that.$emit('removeTab')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/qyxx/QyxxAdd/QyzsRyzzAdd.vue